import React from "react";

const PageTitle = ({ children }) => {
  return <h1 className="text-lg font-medium">{children}</h1>;
};

export default PageTitle;
